import './../App.css';
import '../css/maincomponents/footercomponent.css';
import '../css/maincomponents/competenceitemsgrid.css'
import '../css/maincomponents/footermaincomponent.css';
import '../css/maincomponents/noscompetencecontents.css';
import '../css/maincomponents/devistoggleitemstype.css';
import { Link, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import Axios from 'axios'
import { apiUrl } from '../constants/Constants';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const currentYear = new Date().getFullYear();


export function FooterComponent(props) {
    return <footer class="footer-area">
        <div class="">
            <div><span class="footer-copy-right">&copy;</span> <span class="footer-name">decohome75</span> <span class="footer-year">{currentYear}.</span></div>
        </div>
        <div class="footer-socials">
            <div className='cursor-pointer btnFacebook' onClick={() => { window.open("https://www.facebook.com/RenovationDecohome75", '_blank') }} title="Déco Home 75" target="_blank"><i class="fa fa-facebook"></i></div>
            <div className='cursor-pointer btnInstagram' onClick={() => { window.open("https://www.instagram.com/renovation_dh75/", '_blank') }} title="renovation_dh75" target="_blank"><i class="fa fa-instagram"></i></div>
        </div>
    </footer>
}

export function CompetenceItemsGrid(props) {


    return <div class="row noMargin ">

        <div class="col-12 col-md-4 noPadding categorie-0 ">
            <div class="">
                <div class="section-title white">
                    NOS EXPERTISES
                </div>
                <h2 class="section-heading white">We provide the best renovation solutions</h2>
            </div>
        </div>
        <div class="row col-12 col-md-8 noPadding noMargin">

            <div class="col-6 categorie-1" >
                <Link to="/realisation" class="competencegrid-container" onClickCapture={() => global.globalType = "Rénovation Complète"}>
                    <div class="" >
                        <img src="assets/images/icons/categorie1.png" class="widthIconExpertise" alt="" />
                    </div>
                    <h3 class="competencegridTitle">Rénovation complète</h3>
                    <div class="competencegrid-desc" >
                        Réalisation de travaux de rénovation, en tous corps d'états
                        <div class="service-button mt-20 mb-20 mt-lg-20 local-scroll">
                            <Link to="/realisation" class="btn btn-mod btn-small btn-circle" onClickCapture={() => global.globalType = "Rénovation Complète"}>Découvrir</Link>
                        </div>
                    </div>


                </Link>
            </div>
            <div class="col-6 categorie-2">

                <Link to="/realisation" class="competencegrid-container" onClickCapture={() => global.globalType = "Rénovation Cuisine"}>
                    <div class="" >
                        <img src="assets/images/icons/categorie2.png" class="widthIconExpertise" alt="" />
                    </div>
                    <h3 class="competencegridTitle">Rénovation Cuisine</h3>
                    <div class="competencegrid-desc" >
                        Installation de cuisines équipées incluant meubles, équipements de plomberie, intervention sur le réseau électrique…
                        <div class="service-button mt-20 mb-20 mt-lg-20 local-scroll">
                            <Link to="/realisation" class="btn btn-mod btn-small btn-circle" onClickCapture={() => global.globalType = "Rénovation Cuisine"}>Découvrir</Link>
                        </div>
                    </div>


                </Link>

            </div>
            <div class="col-6 categorie-3">
                <Link to="/realisation" class="competencegrid-container" onClickCapture={() => global.globalType = "Rénovation Salle de Bain"}>
                    <div class="" >
                        <img src="assets/images/icons/categorie3.png" class="widthIconExpertise" alt="" />
                    </div>
                    <h3 class="competencegridTitle">Rénovation salle de bain</h3>
                    <div class="competencegrid-desc" >
                        Réfection des carrelages et faïences, le remplacement des sanitaires par des équipements plus modernes, ou d’une douche par une baignoire…
                        <div class="service-button mt-20 mb-20 mt-lg-20 local-scroll">
                            <Link to="/realisation" class="btn btn-mod btn-small btn-circle" onClickCapture={() => global.globalType = "Rénovation Salle de Bain"}>Découvrir</Link>
                        </div>
                    </div>
                </Link>

            </div>
            <div class="col-6 categorie-4">
                <Link to="/realisation" class="competencegrid-container" onClickCapture={() => global.globalType = "Rénovation Sols et Murs"} >
                    <div class="" >
                        <img src="assets/images/icons/categorie4.png" class="widthIconExpertise" alt="" />
                    </div>
                    <h3 class="competencegridTitle">Rénovation sols et murs</h3>
                    <div class="competencegrid-desc" >
                        Arrachage des papiers peints ou des moquettes existantes et installation de nouveaux revêtements: parquets, carrelages...
                        <div class="service-button mt-20 mb-20 mt-lg-20 local-scroll">
                            <Link to="/realisation" class="btn btn-mod btn-small btn-circle" onClickCapture={() => global.globalType = "Rénovation Sols et Murs"}>Découvrir</Link>
                        </div>
                    </div>
                </Link>
            </div>

        </div>
    </div>
}

export function NosCompetenceContents(pros) {
    return <div class="noMargin">
        <div className='row noMargin'>
            <div class='col-md-9 noPadding'>
                <div className='row noMargin'>

                    <div class="col-md-4 noscompetenceItems noPadding">
                        <div class="">
                            <div class="noscompetenceImage">
                                <img src="assets/images/icons/service5.png" alt="" />
                            </div>
                            <div class="noscompetenceText">
                                <h3 class="noMargin">Maçonnerie</h3>
                                <span class="">
                                    Qu'il s'agisse de rénovation, d'agrandissement ou de petite maçonnerie, nos équipes s'occupent de tout: murage de portes ou de fenêtres, ouverture d'un mur, démolition de cloisons, dailles ou chapes de béton au sol etc...
                                </span>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4 noscompetenceItems noPadding">
                        <div class="">
                            <div class="noscompetenceImage">
                                <img src="assets/images/icons/service2.png" alt="" />
                            </div>
                            <div class="noscompetenceText">
                                <h3 class="noMargin">Plomblerie</h3>
                                <span class="">
                                    Nos équipes prennent en charge tous les éléments nécessaires au bon fonctionnement des sanitaires et de toutes les pièces d'eau: appareils sanitaires, robinetteries, canalisations, alimentation, evacuation, raccordements.
                                </span>
                            </div>
                        </div>
                    </div>


                    <div class="col-md-4 noscompetenceItems noPadding">
                        <div class="">
                            <div class="noscompetenceImage">
                                <img src="assets/images/icons/service4.png" alt="" />
                            </div>
                            <div class="noscompetenceText">
                                <h3 class="noMargin">Menuiserie</h3>
                                <span class="">
                                    Nos équipes réalisent différents aménagements intérieurs: placards, dressings, étagères et autres rangements, ensembles de cuisines, meubles de salles de bain, mezzanines, parquets etc...
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='row noMargin'>
                    <div class="col-md-4 noscompetenceItems noPadding">
                        <div class="">
                            <div class="noscompetenceImage">
                                <img src="assets/images/icons/service1.png" alt="" />
                            </div>
                            <div class="noscompetenceText">
                                <h3 class="noMargin">Electrecité Générale</h3>
                                <span class="">
                                    Nos équipes s'occupent de la rénovation électrique (partielle ou totale) avec dépose de l'installation et mise en place d'un nouveau x`réseau conforme à la norme NFC 15-100.
                                </span>
                            </div>
                        </div>
                    </div>


                    <div class="col-md-4 noscompetenceItems noPadding">
                        <div class="">
                            <div class="noscompetenceImage">
                                <img src="assets/images/icons/service7.png" alt="" />
                            </div>
                            <div class="noscompetenceText">
                                <h3 class="noMargin">Parqueterie</h3>
                                <span class="">
                                    Le parquet n'a plus secret pour nos équipes: de la pose de parquet massif, contrecollé ou stratifié, à la renovation de parquet existant.
                                </span>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4 noscompetenceItems noPadding">
                        <div class="">
                            <div class="noscompetenceImage">
                                <img src="assets/images/icons/service6.png" alt="" />
                            </div>
                            <div class="noscompetenceText">
                                <h3 class="noMargin">Carrelage</h3>
                                <span class="">
                                    Nos équipes s'emploient à la pose ou la réfection des revêtements de sol et muraux.
                                </span>
                            </div>
                        </div>
                    </div>


                </div>
            </div>
            <div className='col-md-3 row noMargin noPadding'>
                <div class="col-md-12 noscompetenceItems noPadding">
                    <div class="">
                        <div class="noscompetenceImage">
                            <img src="assets/images/icons/service3.png" alt="" />
                        </div>
                        <div class="noscompetenceText">
                            <h3 class="noMargin">Peinture et platrerie</h3>
                            <span class="">
                                Nos équipes s'occupent de tous types de peintures extérieures comme intérieures, en tenant compte de certaines contraintes comme les nécessités d'isolation.
                                Confiez vos travaux de platrerie à nos experts artisans : pose de plaques de plâtre, isolation de cloisons, doublage de cloisons, isolation phonique et thermique, pose de faux-plafonds, création de planchers.
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
}

export function InfoFooterGreyView(props) {
    return <div className='row-div padding20 marginTop20'>
        <div className='column-div flexEnd'>
            <text className='size0point6 textWhite montserrat'>{props.title}</text>
            <text className='size1 textWhite montserrat bold'>{props.value}</text>
        </div>
        <div className="vl marginLeft20"></div>
        <img className="white-small-icon marginLeft20 alignSelf" src={props.image} alt="" />
    </div>
}

export function FooterMainComponent(props) {


    const navigate = useNavigate()

    const backgroundStyle1 = {
    };

    const [nom, setNom] = useState("");
    const [email, setEmail] = useState("");
    const [msg, setMsg] = useState("");

    const validateFields = () => {

        if (!email.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)) {
            toast.error("Mauvais format d'email")
        }
        else {
        }
        if (email.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)) {
            sendMessageApi();
        }
    }

    const sendMessageApi = (e) => {
        var formData = new FormData();
        formData.append("nom", nom);
        formData.append("email", email);
        formData.append("msg", msg);

        Axios.post(apiUrl + 'sendContactMessage.php', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then(response => { console.log(response); setEmail(""); setNom(""); setMsg("") })
            .catch(error => { console.log(error); setEmail(""); setNom(""); setMsg("") });
    }
    const mailto = "mailto:renovation@decohome75.fr";


    useEffect(() => {
        document.getElementById("entreprise").classList.remove('onLinkFocus'); document.getElementById("competence").classList.remove('onLinkFocus'); document.getElementById("realisation").classList.remove('onLinkFocus'); document.getElementById("contact").classList.add('onLinkFocus');; document.documentElement.scrollTop = 0
    }, [])

    return (
        <div id='mainCont'>
            <div class="" style={backgroundStyle1}>
                <div class="container mainfooterContainer">
                    <div class="mainfooterHeader" >
                        <div class="mainfooterSocialsContainer">
                            <div class="mainfooterSocials" style={{ alignSelf: "flex-start" }}>
                                <div onClick={() => { window.open('tel:0033658351832', '_blank') }} class="cursor-pointer">
                                    <div class="mainfooterSocialsText"> <i class="fa fa-phone mainfooterMobileIcons"></i> <div class="mainfooterSocialsTitle">Contactez-nous</div></div>
                                    <div class="mainfooterSocialsText">00 33 6 58 35 18 32</div>
                                </div>
                                <div onClick={() => { window.open('tel:0658986068', '_blank') }} class="mainfooterIcons">
                                    <i class="fa fa-phone"></i>
                                </div>
                            </div>
                            <div class="mainfooterSocials">
                                <div class="cursor-pointer" onClick={(e) => { window.open("https://goo.gl/maps/fqKvvc2ux4CpWtzF9", '_blank') }}>
                                    <div class="mainfooterSocialsText"> <i class="fa fa-map-marker mainfooterMobileIcons"></i> <div class="mainfooterSocialsTitle">ADRESSE</div></div>
                                    <div class="mainfooterSocialsText">127 Rue de Javel, 75015 Paris </div>
                                </div>
                                <div onClick={(e) => { window.open("https://goo.gl/maps/fqKvvc2ux4CpWtzF9", '_blank') }} class="mainfooterIcons">
                                    <i class="fa fa-map-marker"></i>
                                </div>
                            </div>
                            <div class="mainfooterSocials" style={{ alignSelf: "flex-end" }}>
                                <div onClick={(e) => {
                                    window.location.href = mailto;
                                    e.preventDefault();
                                }}
                                    className="cursor-pointer">
                                    <div class="mainfooterSocialsText"> <i class="fa fa-envelope mainfooterMobileIcons"></i> <div class="mainfooterSocialsTitle">Adresse électronique</div></div>
                                    <div class="mainfooterSocialsText">renovation@decohome75.fr</div>
                                </div>
                                <div onClick={(e) => {
                                    window.location.href = mailto;
                                    e.preventDefault();
                                }} class="mainfooterIcons">
                                    <i class="fa fa-envelope"></i>
                                </div>
                            </div>
                        </div>
                        <div class="mainfooterForm" >
                            <div class="mainfooterInputs" >
                                <div class="mainfooterLeftInputs">
                                    <div>
                                        <input type="text" class="mainfooterinputItem" name="name" id="name" placeholder="Nom" pattern=".{3,100}" value={nom} onChange={(event) => setNom(event.target.value)} />
                                    </div>
                                    <div >
                                        <input type="email" class="mainfooterinputItem" name="email" id="email" placeholder="Adresse électronique" pattern=".{5,100}" value={email} onChange={(event) => setEmail(event.target.value)} />
                                    </div>
                                </div>
                                <div class="mainfooterTextareaContainer" >
                                    <div class="mainfooterLabel">Message</div>
                                    <div >
                                        <textarea class='mainfooterTextarea' name="message" id="message" value={msg} onChange={(event) => setMsg(event.target.value)}></textarea>
                                    </div>
                                </div>
                            </div>
                            {nom == "" || email == "" || msg == "" ?
                                <div class="footermainsendbuttonContainer">
                                    <div class="home-red-button-disabled home-send-button" >Envoyer</div>
                                </div>
                                :
                                <div class="footermainsendbuttonContainer">
                                    <div class="home-red-button home-send-button" onClick={() => validateFields()}>Envoyer</div>
                                </div>
                            }
                        </div>
                    </div>
                    <div class="mainfooterScrollUp" onClick={() => {
                        window.scrollTo({
                            top: 0,
                            left: 0,
                            behavior: 'smooth'
                        });
                    }}>
                        <i class="fa fa-arrow-circle-o-up mainfooterScrollIcon "></i>
                        <div class="mainfooter-hautdepage">Haut de Page</div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export function DevisToggleItemsType1(props) {
    return <a data-toggle="collapse" role="button">
        <div class="slide pointer">
            <div class="box-info box-info-1 alignCenter column-div  ">
                <div class="box-icon icon">{props.icon}</div>
                <div class="box-content marginTop">
                    <div style={{ minWidth: "70px" }} class="color-white text-12 bold ">{props.title}</div>
                </div>
            </div>
        </div>
    </a>
}

export function DevisToggleItemsType2(props) {
    return <a data-toggle="collapse" role="button">
        <div class="slide pointer">
            <div class="box-info box-info-2 alignCenter column-div  ">
                <div class="box-icon icon">{props.icon}</div>
                <div class="box-content marginTop">
                    <div style={{ minWidth: "120px" }} class="color-white text-12 bold ">{props.title}</div>
                </div>
            </div>
        </div>
    </a>
}